/* eslint-disable jsx-a11y/label-has-for */

import React from 'react';
import PropTypes from 'prop-types';
import { formatPrice } from '../../helpers/formatNumbers';

const ContainerSummary = props => (
  <div className="lineItem" key={`containerSummary-${props.containerId}`}>
    <span className="name truncateText" title={props.name}>{props.name}</span>
    <span className="total">{formatPrice(props.price)}</span>
  </div>
);

ContainerSummary.propTypes = {
  containerId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
};

export default ContainerSummary;
